import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseElement } from '../base-element';
import { FormEvent } from '../../../crud/form/form-event.enum';

@Component({
    selector: 'input-base',
    templateUrl: './base-input.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => BaseInputComponent),
            multi: true,
        },
    ],
})
export class BaseInputComponent extends BaseElement<string> implements OnInit {
    @Input() type = 'text';
    @Input() placeholder: string = '';
    @Input() tooltip = '';
    @Input() labelNoWrap = false;
    @Input() maxLength: number | null = null;
    @Input() hint: string = '';

    error = '';

    ngOnInit(): void {
        if (this.channel) {
            this.channel.subscribe((event: FormEvent) => {
                if (event === FormEvent.SUBMIT) {
                    if (this.form.controls[this.formControlName].invalid) {
                        this.toggleInvalidClass(true);
                        this.renderErrors();
                    } else {
                        this.toggleInvalidClass(false);
                    }
                }
            });
        }
    }

    onChange($event): void {
        this.error = '';
        this.toggleInvalidClass(false);
        if (this.change) {
            this.change.emit($event);
        }
    }

    onKeyup($event): void {
        this.error = '';
        this.toggleInvalidClass(false);
        if (this.keyupEvent) {
            this.keyupEvent.emit($event);
        }
    }

    protected toggleInvalidClass(flag: boolean): void {
        this.customClass = Object.assign(this.customClass, { 'is-invalid': flag });
    }

    protected renderErrors(): void {
        this.error = '';
        if (!this.errorMessages) {
            return;
        }

        if (typeof this.errorMessages === 'string') {
            this.error = this.errorMessages;
        } else {
            const errors = this.form.controls[this.formControlName].errors;
            for (const validator of Object.keys(errors)) {
                if (errors[validator]) {
                    this.error += this.errorMessages[validator] + '<br />';
                }
            }
        }
    }
}
